export default __webpack_public_path__ + "static/media/FICHA TÉCNICA - BANANA NANICA.6d80eeb4.pdf";